var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgPause(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "pause_svg__ionicon",
    viewBox: "0 0 512 512"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M208 432h-48a16 16 0 01-16-16V96a16 16 0 0116-16h48a16 16 0 0116 16v320a16 16 0 01-16 16zm144 0h-48a16 16 0 01-16-16V96a16 16 0 0116-16h48a16 16 0 0116 16v320a16 16 0 01-16 16z",
    fill: "currentColor"
  })));
}

export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIGNsYXNzPSJpb25pY29uIiB2aWV3Qm94PSIwIDAgNTEyIDUxMiI+CiAgPHBhdGggZD0iTTIwOCA0MzJoLTQ4YTE2IDE2IDAgMDEtMTYtMTZWOTZhMTYgMTYgMCAwMTE2LTE2aDQ4YTE2IDE2IDAgMDExNiAxNnYzMjBhMTYgMTYgMCAwMS0xNiAxNnptMTQ0IDBoLTQ4YTE2IDE2IDAgMDEtMTYtMTZWOTZhMTYgMTYgMCAwMTE2LTE2aDQ4YTE2IDE2IDAgMDExNiAxNnYzMjBhMTYgMTYgMCAwMS0xNiAxNnoiIGZpbGw9ImN1cnJlbnRDb2xvciIvPgo8L3N2Zz4=";
export { SvgPause as ReactComponent };